module.exports = "<div layout=\"column\" flex class=\"md-warning\">\n  <f-toolbar></f-toolbar>\n  <div class=\"content not-authorized\" flex layout=\"column\" layout-align=\"center center\">\n    <div class=\"icon\">\n      <i class=\"fa fa-warning\"></i>\n    </div>\n    <h1>Sorry!<br /><small>It seems you don't have permission to do that.</small></h1>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./routes/errors/not-authorized/tpl.html
// module id = 1171
// module chunks = 0